// Gedeelde BTW-helpers: klant-gebaseerde BTW-bepaling voor documenten, snel-scan & kassa.

// EU-lidstaten (ISO 2-letter codes) — voor intracommunautaire BTW-detectie
export const EU_LANDEN = new Set([
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR',
  'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
]);

// Normaliseer een landwaarde naar een 2-letter ISO-code ('België', 'Nederland', 'nl', ...)
export const landNaarIso = (land) => {
  if (!land) return '';
  const s = String(land).trim();
  if (s.length === 2) return s.toUpperCase();
  const lower = s.toLowerCase();
  const map = {
    'belgië': 'BE', 'belgie': 'BE', 'belgium': 'BE',
    'nederland': 'NL', 'netherlands': 'NL', 'holland': 'NL',
    'frankrijk': 'FR', 'france': 'FR',
    'duitsland': 'DE', 'germany': 'DE', 'deutschland': 'DE',
    'luxemburg': 'LU', 'luxembourg': 'LU',
    'spanje': 'ES', 'spain': 'ES', 'españa': 'ES',
    'italië': 'IT', 'italie': 'IT', 'italy': 'IT', 'italia': 'IT',
    'portugal': 'PT', 'oostenrijk': 'AT', 'austria': 'AT',
    'polen': 'PL', 'poland': 'PL', 'tsjechië': 'CZ', 'tsjechie': 'CZ', 'czech': 'CZ',
    'zweden': 'SE', 'sweden': 'SE', 'denemarken': 'DK', 'denmark': 'DK',
    'finland': 'FI', 'ierland': 'IE', 'ireland': 'IE',
    'verenigd koninkrijk': 'GB', 'uk': 'GB', 'united kingdom': 'GB',
    'zwitserland': 'CH', 'switzerland': 'CH',
    'noorwegen': 'NO', 'norway': 'NO',
    'verenigde staten': 'US', 'usa': 'US', 'united states': 'US',
  };
  return (map[lower] || '').toUpperCase();
};

/**
 * Detecteer automatisch de BTW-regel op basis van klant-land + BTW-nummer.
 * Returns: 'intracommunautair' | 'export_eu' | null (= normale BE-BTW).
 * LET OP: het BTW-nummer staat op de klant in het veld `btwnr` (met `btw` als legacy-fallback).
 */
export const detecteerBtwRegel = (klant) => {
  if (!klant) return null;
  const landIso = landNaarIso(klant.land || klant.country);
  if (!landIso || landIso === 'BE') return null;
  const heeftBtwNr = !!((klant.btwnr || klant.btw || '')).trim();
  if (EU_LANDEN.has(landIso)) {
    return heeftBtwNr ? 'intracommunautair' : null;
  }
  return 'export_eu';
};

/**
 * Klant-specifieke standaard BTW (veld `standaard_btw` op klantenfiche).
 * Returns een getal (bv. 0 of 6) wanneer expliciet afwijkend van 21, anders null.
 */
export const klantStandaardBtw = (klant) => {
  if (!klant) return null;
  const raw = klant.standaard_btw;
  if (raw === undefined || raw === null || raw === '') return null;
  const v = parseFloat(String(raw).replace(',', '.'));
  if (!Number.isFinite(v) || v === 21) return null;
  return v;
};

// 0-veilige artikel-BTW: een artikel met btw=0 blijft 0 (en wordt NIET 21).
export const artikelBtw = (art) => {
  const v = parseFloat(art?.btw);
  return Number.isFinite(v) ? v : 21;
};
